import React from 'react'
export const IconError: React.FC = () => {
  return (
    <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.2305 14H17.7305V21.6562H15.2305V14ZM15.2305 23.1875H17.729V26.25H15.2305V23.1875Z" fill="#993844" />
      <path d="M19.4333 5.60531C18.8558 4.61522 17.7308 4 16.4995 4C15.2683 4 14.1433 4.61522 13.5658 5.60682L1.38956 26.5619C1.11937 27.0221 0.985527 27.5385 1.00124 28.0602C1.01695 28.5818 1.18168 29.0908 1.47917 29.5368C1.77237 29.9848 2.18877 30.3554 2.68725 30.612C3.18573 30.8686 3.74906 31.0023 4.32162 31H28.6775C29.8523 31 30.9159 30.4528 31.5216 29.5368C31.8186 29.0906 31.983 28.5817 31.9988 28.0602C32.0145 27.5386 31.8809 27.0223 31.6112 26.5619L19.4333 5.60531ZM4.32162 27.9768L16.4995 7.02166L28.6858 27.9768H4.32162Z" />
    </svg>
  )
}
